import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Utility, { removeDelayedLoader, showDelayedLoader } from "../../utility/Utility";
import { deepClone } from "../../utility/Utility"
import {
  DKLabel,
  DKListPicker,
  DKIcon,
  DKIcons,
  DKStatus,
  showAlert,
  showToast,
  TOAST_TYPE,
  Toggle,
  DKButton,
  showLoader,
  removeLoader
} from "deskera-ui-library";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { parseColumnConfig, EmployeeColumnConfig, changeColumnName, parseVisibleColumnConfig, filedNameByColumnCode, sortColumnMapping, getColumnById } from "../configs/config";
import { fetchEmployee, fetchFilterEmployee, fetchTenantData, selectEmployeeColumnConfig, selectTenanatData } from "../../Redux/Slices/EmployeeListSlice";
import EmployeeListService from "../../services/EmployeeListService";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import { selectEmployee } from "../../Redux/Slices/EmployeeListSlice";
import { fetchPayschedules, fetchTeams, selectPaySchedule } from "../../Redux/Slices/PayrollSlice";
import PayrollService from "../../services/PayrollService";
import { CONSTANTS, EMPLOYEE_FILTER, INPUT_TYPE, PROFILE_STAGES_CONSTANT } from "../../constants/Constant";
import ic_list from "../../assets/icons/white/ic_list_bulleted.svg";
import ic_phone_card from "../../assets/icons/white/ic_contact_phone.svg";
import ic_list_white from "../../assets/icons/white/ic_list_bulleted_white.svg";
import ic_phone_card_white from "../../assets/icons/white/ic_contact_phone_white.svg";
import ViewToggle from "../common/ViewToggle";
import ic_error_card from "../../assets/icons/ic_info_error.svg";
import {convertDateToJson, getLocationColumnName, getQueryParam, getUserProfilePic, showAlertEmployeeExpense, showAlertEmployeeLeave}  from "../../managers/common/CommonUtil"
import Table from "../../services/table";
import CustomFieldService from "../../services/CustomFieldService";
import { fetchCustomFields, selectCustomField } from "../../Redux/Slices/CustomFieldsSlice";
import TerminationPortal from "../employee/TerminationPortal";
import ProfileSetupService from "../../services/ProfileSetup-service";
import TenantManager from "../../managers/TenantManager";
import MessageInfo from "../common/MessageInfo";
import ReadWatchComponent from "../common/ReadWatchComponent";
import AppManager from "../../managers/AppManager";
import { LOCATION_COLUMN_CONFIG } from "../add-employee/steps/Employee";
import { fetchLocationList, selectLocationList } from "../../Redux/Slices/LocationListSlice";
import { getEmployeeExportDataFile, getFile, triggerDownload } from "../import_export/utility/ExportData";
import MaskInputUtil from "../../SharedComponents/MaskInput/MaskInputUtil";
import { fetchContactCustomNumberFormat } from "../../Redux/Slices/CustomNumberFormat";
import RehireEmployree from "../employee/RehireEmployee";
import { isMobileWebView } from "../../utility/ViewportSizeUtils";
import i18next, { t } from "i18next";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import ExpenseService from "../../services/ExpenseService";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
import { Store } from "../../Redux/Store";
import debounce from "../../utility/Debounce";

const EmployeeList = (props) => {

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };


    const data = [
      { id: 0, name: "List", icon: ic_list_white, unselectedIcon: ic_list},
      { id: 1, name: "Card", icon: ic_phone_card_white, unselectedIcon: ic_phone_card},
    ];
    //State hooks
    const [refresh, setRefresh] = useState(false);
    const [employee, setEmployee] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [needSegmentListPicker, setSegmentListPicker] = useState(false);
    const [isFromEmployeeSetup, setFormSetup] = useState(props.isFromEmployeeSetup);
    const [selectedEmployeeFilter, setSelectedEmployeeFilter] = useState(EMPLOYEE_FILTER[0]);
    const [employeeFilters, setEmployeeFilter] = useState(EMPLOYEE_FILTER);
    const [selectedView,setView] = useState(0);
    const filter = getQueryParam(props.location, "filter");
    const [showIncompleteProfiles, setFilterToggle] = useState(filter ? true: false);
    const [isTerminateEmployee, setIsTerminateEmployee] = useState(false);
    const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
    const [reload, setReload] = useState(false);
    const [employeeToBeAddedAsBeneficiary, setEmployeeCountForBeneficiary] = useState(0);
    const [filterArray,setFilterArray] = useState([]);
    const [tenantDetails, setTenantDetails] = useState(TenantManager.getTenantDetails)
    const [exportButtonName, setExportButtonName] = useState('Export Employee')
    const [conditionFilter, setConditionFilter] = useState([])
    const [rehireEmployeePopupData,setRehireEmployeePopupData] = useState();
    const [employeeColumns, setEmployeeColumns] = useState(TableManger.getTableColumns(TABLES.EMPLOYEE_LIST));

    const [mask, setMask] = useState(MaskInputUtil.MASK_STATE);
    const maskUnmaskObservable = MaskInputUtil.subscripeToMaskUnmaskObservable((mask) => {
      setMask(mask);
      setReload(!reload);
    });

    var selectedRow = []
    //Store data selectors
    const dispatch = useDispatch();
    const employeeData = useSelector(selectEmployee);
    const columnConfig = useSelector(selectEmployeeColumnConfig);
    const payscheduleList = useSelector(selectPaySchedule);
    const tenantData = useSelector(selectTenanatData);
    const locationData = useSelector(selectLocationList)
    const isActionEnabled = true;
    const incompleteProfile = [];
    const customFieldsData = useSelector(selectCustomField);

    useEffect(() => {
      return () => {
        MaskInputUtil.unsubscribe(maskUnmaskObservable);
      }
    }, [])

    const deleteConfirm = (data) => [
        {
            title: "Cancel",
            className: "bg-gray1 border-m",
        },
        {
            title: "Delete",
            className: "bg-red text-white ml-r",
            onClick: () => deleteRecord(data),
        },
    ];

    const cannotDeleteOrUpdate = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
    ];

    useEffect(() => {
      RouteManager.setPresenter({ props });
      /* API Calls Start */
      loadEmployee({
            Limit: 20,
            currentPage: '1',
            sort: 'clockIn',
            order: localStorage.getItem("EMP.SORT.ORDER") || 'desc',
            field: localStorage.getItem("EMP.SORT.FIELD") || `_id`,
            searchField: ``,
            searchString: ``,
            isInCompleteProfile: showIncompleteProfiles
      });
      loadCustomSequence({});
      loadPayscheduleList({});
      loadCustomFields({});
      loadTenantData({});
      loadLocationsDetails({})
      /* API Calls End */
      return () => {
        if(EmployeeListService.filterArray) {
          EmployeeListService.filterArray = null;
        }
        setEmployee(initialState)
      };
    }, [props.isUpdate]);

    useEffect(() => {
      if (!Utility.isEmpty(employeeData)) {
        const { users, filterConfig, beneficiariesToAdd } = employeeData;
        const { tenant } = tenantData;
        const { customFields } = customFieldsData;
        const isCashfreeEnabled =
          tenant && tenant.isCashfreeEnabled ? tenant.isCashfreeEnabled : false;
        const { schedules, filterResponse } = payscheduleList;
        const functionConfig = getFunctionConfig();
        const rowData = EmployeeColumnConfig(
          users,
          schedules,
          isFromEmployeeSetup,
          isCashfreeEnabled,
          functionConfig,
          tenant,
          tenantDetails,
          mask,
          customFields
        );
        const additionalSettings = tenantDetails
          ? tenantDetails.additionalSettings
          : "";
        const locationSettings = additionalSettings
          ? additionalSettings?.["LOCATION"]
          : {};
        const isLocationActive = locationSettings?.trackLocation || false;
        let columns = parseColumnConfig(
          TableManger.getTableColumns(TABLES.EMPLOYEE_LIST),
          TABLES.EMPLOYEE_LIST
        );

        let employeeColumn = parseVisibleColumnConfig(columns);
        if (isCashfreeEnabled) {
            employeeColumn.push({
                id: "cashfreeStatus",
                key: "cashfreeStatus",
                columnCode: "cashfreeStatus",
                name: "Beneficiary Status",
                type: INPUT_TYPE.TEXT,
                width: 200,
                editable: false,
                uiVisible: true
            });
        }

        employeeColumn = !isFromEmployeeSetup && isLocationActive ? updateEmployeeColumnConfig(employeeColumn, tenantDetails) : employeeColumn;
        changeColumnName(employeeColumn, "", TABLES.PEOPLE_COMPONENT, { isFromEmployeeSetup: isFromEmployeeSetup });
        employeeColumn = updateColumnConfigWithCustomField(employeeColumn, isCashfreeEnabled);
        const passingData = {
          columnData: deepClone(employeeColumn),
          rowData,
          filter: [],
          originalData: rowData,
        };

        setEmployeeColumns(passingData['columnData']);
        setEmployee(passingData);
        setTotalPageCount(parseInt(filterConfig.totalPage));
        setCurrentPage(parseInt(filterConfig.page));
        setTotalCount(parseInt(filterConfig.numberOfRecords));
        setEmployeeCountForBeneficiary(parseInt(beneficiariesToAdd));
      }
    }, [
      employeeData,
      payscheduleList,
      selectedView,
      reload,
      tenantData,
      locationData,
    ]);

    useEffect(() => {
      if (!Utility.isEmpty(employeeData)) {
        const { users} = employeeData;
        if (showIncompleteProfiles && users.length == 0) {
          ProfileSetupService.updateStateOfProfileStage(
            PROFILE_STAGES_CONSTANT.EMPLOYEE_DETAILS
          ).then((res) => {
            TenantManager.setProfileData(res["profileStages"]);
          });
        } else {
          EmployeeListService.getIncompleteUsers().then((res) => {
            if (res["users"] && res["users"].length == 0) {
              ProfileSetupService.updateStateOfProfileStage(
                PROFILE_STAGES_CONSTANT.EMPLOYEE_DETAILS
              ).then((res) => {
                TenantManager.setProfileData(res["profileStages"]);
              });
            }
          });
        }
      }
    }, [employeeData, showIncompleteProfiles])


    const loadEmployee = async (config) => {
        try {
            EmployeeListService.apiConfig = config;
            const timeout = showDelayedLoader();
            await dispatch(fetchEmployee());
            Store.dispatch(fetchTeams());
            removeDelayedLoader(timeout);
        } catch (err) {
            console.error('Error loading contacts: ', err);
        }
    };
    const loadFileterEmployee = async (config) => {
      try {
        let apiConfig = {
          ...EmployeeListService.apiConfig,
          Limit: 20,
          currentPage: '1'
        };
        EmployeeListService.apiConfig = apiConfig;
        EmployeeListService.filterArray = config;
        await dispatch(fetchFilterEmployee());
      } catch (err) {
        console.error('Error loading employee: ', err);
      }
    }

    const loadPayscheduleList = async (config) => {
      try {
        config = {
          Limit: 1000,
          CurrentPage: 1,
          Order: "desc",
          Field: "_id",
        };
        PayrollService.apiConfig = config;
        await dispatch(fetchPayschedules());
      } catch (err) {
        console.error("Error loading PaySchedules: ", err);
      }
    };

    const loadCustomSequence = async (config) => {
      try {
        await dispatch(fetchContactCustomNumberFormat());;
      } catch (err) {
        console.error("Error loading PaySchedules: ", err);
      }
    };

    const loadCustomFields = async (config) => {
      try {
        config = {
          ...CustomFieldService.apiConfig,
          Module: "employee_details",
        };
        CustomFieldService.apiConfig = config;
        await dispatch(fetchCustomFields());
      } catch (err) {
        console.error("Error loading custom fields data: ", err);
      }
    };

    const loadTenantData = async (config) => {
      try {
        await dispatch(fetchTenantData());
      } catch (err) {
        console.error("Error loading tenant data: ", err);
      }
    };

    const loadLocationsDetails = async () => {
      try {
        await dispatch(fetchLocationList());
      } catch (err) {
        console.error("Error loading custom fields data: ", err);
      }
    };

    const onDeleteContact = (data) => {
      let isMultiDelete = (data && data.length >0 ? true : false);

      const row = data && data.rowData ? data.rowData : {};
      if (row && row.userId && !isMultiDelete) {
        let owner = row.roles.filter(
          (role) =>
            role.appName === "PEOPLE" &&
            (role.name === "ADMIN" || role.name === "OWNER")
        );
        if (owner && owner.length > 0) {
          showAlert(
            "Sorry!!",
            "Employee with Admin role cannot be deleted",
            cannotDeleteOrUpdate
          );
        } else {
          showAlert(
            "Delete Record?",
            "Are you sure you want to delete this record? This action cannot be undone later.",
            deleteConfirm([row])
          );
        }
      } else if(isMultiDelete) {
        let isAdmin = false;
        data.forEach(rows=>{
          if (rows && rows.userId) {
            let owner = rows.roles.filter(
              (role) =>
                role.appName === "PEOPLE" &&
                (role.name === "ADMIN" || role.name === "OWNER")
            );
            if (owner && owner.length > 0) {
              isAdmin = true;
            }
          }
        })
        if(!isAdmin) {
          showAlert(
            "Delete Record?",
            "Are you sure you want to delete this record? This action cannot be undone later.",
            [
              {
                  title: "Delete",
                  className: "bg-red text-white",
                  onClick: () => {
                    deleteRecord(data)
                  }
              },
              {
                  title: "Cancel",
                  className: "ml-m border-m",
                  onClick: () => {
                    loadEmployee({
                      ...EmployeeListService.apiConfig
                    })
                  }
              }
          ]
            
          );
        } else {
          showAlert(
            "Sorry!!",
            "Employee with Admin role cannot be deleted",
            cannotDeleteOrUpdate
          );
        }
      }
    };

    const deleteRecord = (data) => {
      const iamUserIds = data.map(d=>d?.data?.iamUserId) || [];
      ExpenseService.isUserInExpenseApproval(iamUserIds).then(res=>{
        ExpenseService.isUserInExpenseApproval(iamUserIds, false, null, true).then(resLeave=>{
          deleteUser(data);
        },error=>{
          showAlertEmployeeLeave('delete')
          loadEmployee({
            ...EmployeeListService.apiConfig
          })
        })
        
      },error=>{
        showAlertEmployeeExpense('delete')
        loadEmployee({
          ...EmployeeListService.apiConfig
        })
      })      
    }
    const deleteUser =(data)=>{
      const userId = [];
      data.forEach(row=>{
        userId.push(row.userId)
      })
      const parameter = {ids : userId};
      showLoader() 
      Table.deleteEmployee(parameter).then((data) => {
        removeLoader()
        showToast("Record Deleted Successfully", TOAST_TYPE.SUCCESS);
        loadEmployee({
          ...EmployeeListService.apiConfig,
          searchString: selectedEmployeeFilter.id,
          searchField: selectedEmployeeFilter.searchField,
          customJson:{
            searchString: selectedEmployeeFilter.id,
            searchField: selectedEmployeeFilter.searchField,
          }
        });
      },error=>{
        removeLoader()
      })
    }

    const onRowEdit = (data) => {
      let rowData = data && data.rowData ? data.rowData : (data && data.length >0 ? data[0]: "");
      if(rowData && rowData.userId) {
        RouteManager.navigateToPage(
          PAGE_ROUTES.EMPLOYEE_DETAILS,
          `&id=${rowData.userId}&isEdit=true&step=0`
        );
      }
    };
    const rehireEmployee = (data) => {
      setRehireEmployeePopupData(data)
    }
    
    const onCloseRehirePopup = (refresh) => {
      if(refresh) {
        loadEmployee({
          ...EmployeeListService.apiConfig
        })
      }
      setRehireEmployeePopupData(null)
    }
  const terminateEmployee = (data) => {
    const rowData = data && data.rowData ? data.rowData : "";

      if (( rowData.roles.filter(role => role.name === "ADMIN")).length > 0) {
        showToast('Admin can not be terminated', TOAST_TYPE.FAILURE);
        return
      }


    if (rowData) {
      if (rowData['status'][0] === "terminated") {
        showToast('Selected empoyee has already terminated.', TOAST_TYPE.FAILURE);

      } else {
        if (rowData) {
          const iamUserIds = [rowData.data.iamUserId] || [];
          ExpenseService.isUserInExpenseApproval(iamUserIds).then(res => {
            ExpenseService.isUserInExpenseApproval(iamUserIds, false, null, true).then(resLeave => {
              setSelectedEmployeeId(rowData.userId)
              setIsTerminateEmployee(true)
            }, error => {
              showAlertEmployeeLeave('terminate')
            })
          }, error => {
            showAlertEmployeeExpense('terminate')
            
          })
          

        }
      }
    }
  }

  const onTerminateEmployeeClose = () => {
    setIsTerminateEmployee(false)
  }

    const onSearch = (searchTerm) => {
      if (searchTerm != Utility.STRING_EMPTY) {

        let obj = {
          colId: 'name', //default on name // filedNameByColumnCode(columnSelected.columnCode,TABLES.EMPLOYEE_LIST)
          value: searchTerm,
          opr: 'c'
        }
        setConditionFilter([obj])
        loadFileterEmployee({
          conditions: [obj]
        });
      } else {
        setConditionFilter([])
        EmployeeListService.filterArray = null;
        loadEmployee({...EmployeeListService.apiConfig})
      }
    };
    const newColumnAdded = (data) => {
        const columns = employee.columnData;
        columns.push(data);
        setEmployee({ ...employee, columnData: columns });
    };

    const onFilter = (updatedList, queries) => {

      let value;
      let columnSelected ;
      let conditionList = [];
      const {isLocationActive, locationColumnName} = getLocationColumnName(tenantDetails)
      if(queries.length != 0) {
        queries.forEach(query=>{
          columnSelected = getColumnById(employeeColumns,query.key);
          if(Array.isArray(query.value)){
            value = query.value[0]? query.value[0]: '';
          } else if (columnSelected && columnSelected.type === "date") {
            value = convertDateToJson(query.value)
          } else {
            value = query.value
          }
          let obj = {
            colId: filedNameByColumnCode(columnSelected.columnCode,TABLES.EMPLOYEE_LIST, locationColumnName),
            value: value,
            opr: query.condition,
            key: getKeyValue(filedNameByColumnCode(columnSelected.columnCode,TABLES.EMPLOYEE_LIST, locationColumnName)),
            type : columnSelected.type
          }
          conditionList.push(obj)
        })
        if( (columnSelected && columnSelected.columnCode)) {
          let searchObj = {
            searchField: columnSelected.columnCode,
            id: value
          }
          if(columnSelected.columnCode == 'status') {
            let index = EMPLOYEE_FILTER.findIndex(emp=>emp.id==value)
            if(index !=-1) {
              setSelectedFilterData(EMPLOYEE_FILTER[index])
            } else {
              setSelectedEmployeeFilter(EMPLOYEE_FILTER[0]);
            }
          } else {
            const config = {
              ...EmployeeListService.apiConfig,

              customJson:{
                'searchField': filedNameByColumnCode(columnSelected.columnCode,TABLES.EMPLOYEE_LIST, locationColumnName),
                'order': 'asc',
                'searchString':value
              }

            };
            setConditionFilter(conditionList)
            loadFileterEmployee({
              conditions:conditionList
            });
            setSelectedEmployeeFilter(EMPLOYEE_FILTER[0]);
          }

        }
      } else {
        setConditionFilter(conditionList)
        const config = {
          ...EmployeeListService.apiConfig,
          searchString: '',
          searchField: '',
          customJson: null
        };
        EmployeeListService.filterArray = null;
        loadEmployee(config);
        setSelectedEmployeeFilter(EMPLOYEE_FILTER[0]);
      }
      setFilterArray(queries);

    };

    const onRowAdd = (newRow) => {
        // if (newRow) {
        //     let updatedRowData = [...contacts.rowData];
        //     updatedRowData.unshift(newRow);
        //     setContacts({
        //         ...contacts,
        //         rowData: updatedRowData,
        //         originalData: updatedRowData
        //     });
        // }
    };

    const showEmployeeFilterList = (value) => {
        if (needSegmentListPicker === false) {
            setSegmentListPicker(true);
        }
    };

    const hideEmployeeFilterList = (value) => {
        setSegmentListPicker(false);
    };

    const getEmployeeFilters = () => {
        let filters = employeeFilters;
        return filters.map(function (item, index) {
          return item.name || "";
        });
    }

    const setSelectedFilterData = (data) => {
      if (selectedEmployeeFilter.id != data.id) {
        setSelectedEmployeeFilter(data);
        loadEmployee({
          ...EmployeeListService.apiConfig,
          Limit: 20,
          currentPage: '1',
          searchString: data.id,
          searchField: data.searchField,
          customJson:{
            searchString: data.id,
            searchField:data.searchField
          }
        });
        setFilterArray([]);
      }
    };

    const onViewChange = (data, index) => {
      setView(data.id);
    }

    const getProfileImage = (user) => {
      let profileMeta = {
        name:
          user.firstName + CONSTANTS.EMPTY_STRING_WITH_SPACE + user.lastName,
        backgroundColor: "#001F42",
        textColor: "#FFF",
        font: "bold 24px sans-serif",
        height: 72,
        width: 72,
      };
      return getUserProfilePic(profileMeta);
    }

    const updateColumnConfigWithCustomField = (columnConfig) => {
        let fieldConfig  = customFieldsData?.customFields?.filter(field=>field.isActive) || [];
        const compensationIndex = columnConfig.findIndex(col=>col.columnCode === "compensation");
        if(compensationIndex !== -1 && TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
          columnConfig[compensationIndex].name = t("PW_BASIC_SALARY");
        }
        fieldConfig?.forEach((c) => {
            let group = {
                name:c.name,
                columnCode:c.id,
                id:c.id,
                key:c.id,
                width:150,
                editable:false,
                uiVisible :true
            };
            group = getFieldConfigOnType(group,c);
            columnConfig.push(group);
        });
        return columnConfig;
    }

    const getFieldConfigOnType = (group, c) => {
        switch(c.type) {
            case "text":
                group['type'] = INPUT_TYPE.TEXT;
                break;
            case "number":
                group['type'] = INPUT_TYPE.NUMBER;
                break;
            case "multiselect":
                const options = c.possibleValues.map((p) => {
                    return{
                        id:p,
                        name:p
                    }
                });
                group['type'] = INPUT_TYPE.MULTI_SELECT;
                group['options'] = options;
                break;
            case "date":
                group['type'] = INPUT_TYPE.DATE;
                break;
            default:
                group['type'] = INPUT_TYPE.TEXT;
        }
        return group;
    }

    const getKeyValue = (value) => {
        const fields = ["customFields"];
        let key = CONSTANTS.EMPTY_STRING;
        fields.forEach((f) => {
            switch (f) {
                case "customFields":
                    const { customFields } = customFieldsData || [];
                    let index = customFields?.findIndex((c) => c.id === value )
                    if (index != -1) key = "custom_field";
                    break;
            
                default:
                    break;
            }
        })
        return key;
    }

    const getCard = () => {

      let users = employeeData && employeeData.users ? employeeData.users : [];
      // users.map((user, index) => {
        return (
          <div
            className={`p-h-l pt-r pb-l border-m shadow-s border-radius-m border-box dashboard-card column align-items-center parent-width
                ${
                  incompleteProfile.length > 0
                    ? "incomplete-profile-row"
                    : "bg-white"
                } `}
            style={{ width: "24%" }}
          >
            <div className="row">
              <div
                className=""
                style={{
                  borderRadius: "16px",
                  backgroundColor: "#e8f5e9",
                }}
              >
                <div
                  className="fs-s fw-m"
                  style={{ padding: "6px 12px 6px 12px" }}
                >
                  <DKStatus title="Active" color="bg-green" />
                </div>
              </div>
            </div>

            <div className="row mt-m">
              <div className="column w-70">
                <div className="d-flex parent-width">
                  <div className="fw-m fs-l ellipsis width-90">

                  </div>
                  <DKIcon src={ic_error_card} className="ic-s" />
                </div>
                <div className="text-gray ellipsis ">Developer</div>
              </div>
              <div className="column w-30" style={{ alignItems: "flex-end" }}>
                <DKIcon
                  src={getProfileImage({
                    firstName: "AAA",
                    lastName: "BBB",
                  })}
                  className="border-radius-l ic-m"
                />
              </div>
            </div>

            <div className="row mt-l">
              <div className="column w-50">
                <div className="d-flex text-gray fs-m parent-width ellipsis">
                  Employee ID
                </div>
                <div className="d-flex fw-m fs-m parent-width ellipsis">
                  00007
                </div>
              </div>
              <div className="column w-50" style={{ paddingLeft: "15px" }}>
                <div className="d-flex text-gray fs-m parent-width ellipsis">
                  {i18next.t("BASIC_SALARY")}
                </div>
                {/* <div className="row"> */}
                <div className="fw-m fs-m parent-width ellipsis">
                  0.000000000000000/Year
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>
        );
      // });

    }

    const filterIncompleteProfiles = () => {
      setFilterToggle(!showIncompleteProfiles);
      loadEmployee({
        ...EmployeeListService.apiConfig,
        isInCompleteProfile: !showIncompleteProfiles,
        Limit: 20,
        currentPage: '1',
        customJson:{
          searchField: selectedEmployeeFilter.searchField,
          searchString : selectedEmployeeFilter.id
        }
      });
      setFilterArray([]);
    }

    const onCreateNew = () => {
      RouteManager.navigateToPage(
        PAGE_ROUTES.EMPLOYEE_DETAILS,
        `&isEdit=false&step=0`
      );
    }

    const onContextCancel = () => {
      setReload(!reload)
  }

  const getBannerMessageForEmployeeList = () => {
    let messageGroup = [
      {
        message: `Please note that your <b>${employeeToBeAddedAsBeneficiary}</b> employee(s) with Payment method as Direct Deposit or UPI are not added as a beneficiaries`,
        isAction: true,
        action: (data) => onBannerClickAction(data),
        actionText: "Click here",
        addtionalText: " to sync them as a beneficiaries.",
      },
    ];
    return messageGroup;
  }

  const onView = (data) => {
    let rowData = data && data.rowData ? data.rowData : (data && data.length >0 ? data[0]: "");
      if(rowData && rowData.userId) {
        RouteManager.navigateToPage(
          PAGE_ROUTES.EMPLOYEE_VIEW,
          `id=${rowData.userId}`
        );
      }
  }

  const onBannerClickAction = (data) => {
    Table.syncBeneficiary().then((res) => {
      if(res) {
        showToast("Syncing is in progress, please check after sometime", TOAST_TYPE.SUCCESS);
      }
    },
    (err) => {
      showToast("Something went wrong", TOAST_TYPE.ERROR);
    });
  }

  const getFunctionConfig = () => {
    let config = {
      "deleteEmployee": onDeleteContact,
      "terminateEmployee": terminateEmployee,
      "viewEmployee": onView,
      "rehireEmployee": rehireEmployee,
    };
    return config;
  }
  
  const onSort = (data) => {
    const sortField = sortColumnMapping(data);
    const sortOrder = data.order.toLowerCase();
    localStorage.setItem("EMP.SORT.FIELD", sortField);
    localStorage.setItem("EMP.SORT.ORDER", sortOrder);

    loadEmployee({
        ...EmployeeListService.apiConfig,
        order: sortOrder,
        field: sortField,
        customJson: null
    });
  }

  const updateEmployeeColumnConfig = (columnConfig, tenantDetails) => {
    const additionalSettings = tenantDetails
      ? tenantDetails.additionalSettings
      : "";
    const locationSettings = additionalSettings
      ? additionalSettings?.["LOCATION"]
      : {};
    const isLocationActive = locationSettings?.trackLocation || false;
    const columnName = isLocationActive ? locationSettings?.locationLabel : "";
    const locationColumn = LOCATION_COLUMN_CONFIG;
    const locationOptions = locationData && locationData.map((x) => {
      return {
        id: x.id,
        name: x.label,
      };
    });
    locationColumn["name"] = columnName;
    locationColumn["columnCode"] = columnName;
    locationColumn["key"] = columnName;
    locationColumn["id"] = columnName;
    locationColumn["options"] = locationOptions;
    columnConfig.push(locationColumn);
    return columnConfig;
  }

  const onColumnRowUpdate = (data) => {
    const additionalSettings = tenantDetails
      ? tenantDetails.additionalSettings
      : "";
    const locationSettings = additionalSettings
      ? additionalSettings?.["LOCATION"]
      : {};
    const isActiveLocation = locationSettings?.trackLocation || false;
    const locationLabel = locationSettings?.locationLabel || "";
    const columnName = data?.columnKey;
    switch(columnName) {
      case `${locationLabel}`:
        console.log(data);
        break;
    }
  }

  const exportEmployee = () => {
    if(employee.rowData?.length == 0) {
      showToast('No records to export.', TOAST_TYPE.FAILURE);
      return
    }
    console.log(selectedRow)
    const queryParams = {
      format: 'XLSX',

    };

    var selectedUsers = selectedRow.filter(function(item) {
      return item;
  }).map(function(item) {
      return item.userId;
  });
    let data = {
      isInCompleteProfile: showIncompleteProfiles,
      includeDraft: true,
      userIds : selectedUsers,
      conditions: conditionFilter
    }

    if(!Utility.isEmpty(selectedEmployeeFilter.searchField)){
      data["searchField"] = selectedEmployeeFilter? selectedEmployeeFilter.searchField : ""
      data["searchString"] = selectedEmployeeFilter? selectedEmployeeFilter.id : ""

    }

    
    setExportButtonName('Exporting...')
    getEmployeeExportDataFile(queryParams, data)
    .then((res) => res.blob())
    .then((blob) => {
      if (blob?.size > 0) {
        const file = getFile(blob, "Employee", "xlsx");
        triggerDownload(file, file.name);
        setExportButtonName('Export Employee')
        showToast('Employee exported Successfully', TOAST_TYPE.SUCCESS);
        setReload(!reload);
      } else {
          setExportButtonName('Export Employee')
          showToast('Internal server error.', TOAST_TYPE.error);
          setReload(!reload);
      }
    })
    .catch((err) =>{
      setExportButtonName('Export Employee');
      showToast('Internal server error.', TOAST_TYPE.error);
      setReload(!reload);
    });

  }

  const showOpenBtn = () => { 
    if (TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED)) {
      return PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.VIEW]);
    }
    return false;
  }

    return (
      <>
        {/* <div className="parent-width parent-height"> */}
        {!isFromEmployeeSetup && (
          <>
            <div className="mb-l row">
              <div className="row banner-holder">
                <ReadWatchComponent
                  title="Need help getting started? Learn more about creating Employees."
                  onRead={() =>
                    window.open(
                      "https://www.deskera.com/care/view-edit-delete-terminate-employee-deskera-hris/",
                      "_blank"
                    )
                  }
                  onWatch={AppManager.showComingSoonWarning}
                />
              </div>

              {(PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.IMPORT]) || (!isMobileWebView()) &&  PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EXPORT])) &&
              <div className="column bg-deskera-secondary p-r border-radius-m border-m parent-width ml-l banner-holder parent-height">
                <DKLabel text='<span style="font-size:20px">💼</span> Manage your Employee.' />

                <div className="row mt-r">
                  {PermissionUtils.hasAccess(MODULE.EMPLOYEE,[ACTION.IMPORT])&&<DKButton
                    title="Import Employee"
                    // isReverse={true}
                    icon={DKIcons.ic_import}
                    className="border-m bg-white mr-l"
                    onClick={() =>
                      RouteManager.navigateToPage(
                        PAGE_ROUTES.IMPORT_EMPLOYEE,
                        `module=${TABLES.EMPLOYEE}&origin=${PAGE_ROUTES.EMPLOYEE_LIST}`
                      )
                    }
                  />}
                    {((!isMobileWebView()) && PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EXPORT])) &&
                    <DKButton
                      title={exportButtonName}
                      icon={DKIcons.ic_export}
                      className="border-m bg-white"
                      onClick={() => {
                        exportEmployee();
                      }}
                    />}
                  {/* {this.state.showExportPicker ? (
                      <DKListPicker
                        className="position-absolute border-m shadow-m z-index-3"
                        style={{ top: 30, left: 0, minWidth: 100 }}
                        data={this.exportTypes}
                        onSelect={(index) =>
                          this.onSelectExportType(this.exportTypes[index])
                        }
                        onClose={() => {
                          setTimeout(() => {
                            this.setState({ showExportPicker: false });
                          }, 10);
                        }}
                      />
                    ) : null} */}
                  {/* </div> */}
                </div>
              </div>}
            </div>
          </>
        )}
        {!isFromEmployeeSetup &&
          tenantData &&
          tenantData.tenant &&
          tenantData.tenant.isCashfreeEnabled &&
          employeeToBeAddedAsBeneficiary > 0 && (
            <div className="row">
              <MessageInfo
                message={getBannerMessageForEmployeeList()}
                bannerClass="mb-l"
                isClosable={false}
              />
            </div>
          )}
        <div className="row" style={{ justifyContent: "flex-end" }}>
          {!isFromEmployeeSetup && (
            <>
              <div
                className="row"
                style={{ justifyContent: "flex-end" }}
              >
                <Toggle
                  className="border-n"
                  isOn={showIncompleteProfiles}
                  onChange={() => filterIncompleteProfiles()}
                />
                <DKLabel
                  className="m-v-s ml-s mr-m"
                  text={"Show Incomplete Profiles"}
                />
              </div>
              <div
                className="row justify-content-between p-h-r p-v-s border-app border-radius-s position-relative cursor-hand"
                style={{ maxWidth: 250 }}
              >
                <div
                  className="parent-height parent-width position-absolute"
                  style={{ top: 0, left: 0, zIndex: 2 }}
                  onClick={(e) => showEmployeeFilterList()}
                />
                <DKLabel
                  className="fw-m unselectable text-app"
                  text={selectedEmployeeFilter?.name}
                />
                <DKIcon
                  src={DKIcons.ic_arrow_down2}
                  className="ic-s unselectable"
                />
                {needSegmentListPicker && (
                  <DKListPicker
                    data={getEmployeeFilters()}
                    className="position-absolute border-m shadow-m parent-width"
                    style={{ top: 36, left: 0, zIndex: 99999 }}
                    onSelect={(index, value) => {
                      setSelectedFilterData(employeeFilters[index]);
                      hideEmployeeFilterList();
                    }}
                    onClose={(e) => hideEmployeeFilterList()}
                  />
                )}
              </div>
            </>
          )}
          {false && (
            <ViewToggle
              data={data}
              selectedView={0}
              onViewChange={onViewChange}
            />
          )}
        </div>
        {selectedView == 0 && (
          <div className="column parent-width flex-1">
            <div className="column mt-l parent-width mb-s position-relative flex-1">
              <DataGridHolderPayroll
                tableName={TABLES.EMPLOYEE_LIST}
                displayTableName={TABLE_DISPLAY_NAME[TABLES.EMPLOYEE_LIST]}
                
                allowColumnDelete={false}
                allowColumnShift={false}
                allowSearch={true}
                allowFilter={true}
                allowColumnAdd={false}
                onRowDelete={onDeleteContact}
                onRowEdit={(data) => {
                  onRowEdit(data);
                }}
                onCancelContext={() => {
                  onContextCancel();
                }}
                onTerminateEmployee={terminateEmployee}
                refresh={refresh}
                allowRowAdd={!isFromEmployeeSetup}
                addButtonConfig={PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.CREATE]) ? [{
                  title: "+ Add Employee",
                  className: "bg-app text-white ml-s",
                  onClick: () => onCreateNew(),
                }] : []}
                onSelection={(data)=>{
                  selectedRow = data
                }}
                allowDataExport={false}
                gridData={employee}
                onSearch={debounce(onSearch,500)}
                onColumnAdd={newColumnAdded}
                onFilter={onFilter}
                filter={filterArray}
                onRowAdd={onRowAdd}
                onPaginationClick={(requestedPageNumber) => {
                  const config = {
                    ...EmployeeListService.apiConfig,
                    currentPage: requestedPageNumber,
                  };
                  loadEmployee(config);
                }}
                currentPage={currentPage}
                totalPageCount={totalPageCount}
                isActionEnabled={isActionEnabled}
                contextMenu={!isFromEmployeeSetup}
                isMenuVisible={!isFromEmployeeSetup}
                allowRowEdit={PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EDIT]) || showOpenBtn()}
                showContextEdit={false}
                onView = {(data) => onView(data)}
                onSort={(data)=>{onSort(data)}}
                onRowUpdate={(data) => {onColumnRowUpdate(data)}}
                onColumnShift={(data)=> setReload(!reload)}
                module={MODULE.EMPLOYEE}
              />
            </div>
          </div>
        )}
        {selectedView == 1 && (
          <div className="row flex-wrap mt-r justify-content-between align-items-stretch dashboard-card-wrapper pb-xxl">
            {getCard()}
            {/* {employeeData.users && employeeData.users.map(
              (user, index) => {

              }
            )} */}
          </div>
        )}
        {isTerminateEmployee && (
          <div>
            <TerminationPortal
              module={TABLES.EMPLOYEE_TERMINATION}
              origin={PAGE_ROUTES.EMPLOYEE_LIST}
              id={selectedEmployeeId}
              step="0"
              close={(refresh) => {
                onTerminateEmployeeClose();
                if (refresh) {
                  const apiConfig = {
                    ...EmployeeListService.apiConfig
                  }
                  loadEmployee(apiConfig);
                }
              }}
            />
          </div>
        )}
        {rehireEmployeePopupData &&
          <RehireEmployree
            data={rehireEmployeePopupData}
            onClose={onCloseRehirePopup} />
        }
        {/* </div> */}
        {/* </div> */}
      </>
    );
}

export default EmployeeList;
